module.exports = __webpack_public_path__ + "img/act_success.d20542a1.png";